module.exports = __webpack_public_path__ + "img/exp-bill.eab11913.jpg";